import React from "react";

const OnboardBriefcase = ({
  width = 44,
  height = 44,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1651_3034)">
        <rect x="2" y="1" width="40" height="40" rx="20" fill="white" />
        <rect
          x="2.5"
          y="1.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#E2E4E9"
        />
        <path
          d="M24.25 14.25C24.664 14.25 25 14.586 25 15V16.5H28.75C29.164 16.5 29.5 16.836 29.5 17.25V27C29.5 27.414 29.164 27.75 28.75 27.75H15.25C14.836 27.75 14.5 27.414 14.5 27V17.25C14.5 16.836 14.836 16.5 15.25 16.5H19V15C19 14.586 19.336 14.25 19.75 14.25H24.25ZM25 18H19V26.25H25V18ZM16 18V26.25H17.5V18H16ZM23.5 15.75H20.5V16.5H23.5V15.75ZM26.5 18V26.25H28V18H26.5Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1651_3034"
          x="0"
          y="0"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1651_3034"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1651_3034"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default OnboardBriefcase;
